import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
  TagInput,
} from "../../../component/form/form-layout";
import LeftSidePopupLayout from "../../../component/popup/modal-layout";
import XCloseIcon from "../../../component/icons/x-close";
import { GlobalContext } from "../../../context/Context";

const htmlToText = (html = "") => {
  return html
    .replace(/\t/g, "") // remove tabs
    .replace(/\r/g, "") // remove carriage returns
    .replace(/<\/li>/gi, "\n") // li end → newline
    .replace(/<br\s*\/?>/gi, "\n") // br → newline
    .replace(/<[^>]*>/g, "") // remove all other HTML tags
    .replace(/&amp;/g, "&") // decode &amp;
    .replace(/\n\s*\n+/g, "\n") // remove multiple empty lines
    .trim(); // trim start/end
};

const UpdateLeadStatus = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  statusdata = {},
  statusList = [],
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const statusOptions = statusList
    ?.filter((st) => Number(st?.status) === 1)
    ?.map((pr) => ({
      label: pr?.value,
      value: pr?.id,
    }));

  useEffect(() => {
    console.log("data", statusdata);

    if (statusdata?.leadid) {
      formik.setFieldValue("leadstatus", statusdata?.status_code);
    }
  }, []);

  const validationSchema = yup.object({
    leadstatus: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      leadstatus: statusdata?.status || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        leadstatus: values.leadstatus,
      };

      console.log("data ", data);

      try {
        const url = `leads/update-lead-status/${statusdata?.leadid}`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        onSubmit(apiRes?.message || "Update Status successfully");
        formik.resetForm();
        onClose();
      } catch (error) {
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-5 `}
      >
        <div className="flex flex-col h-full gap-5 w-full overflow-hidden">
          <div
            className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
          >
            <h4>{statusdata?.leadid ? "Update" : "Add"} Lead Status</h4>
            <div
              onClick={onClose}
              className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
            >
              <XCloseIcon />
            </div>
          </div>
          {/* Body */}
          <div
            className={`${Style.modal_body} w-full h-full overflow-hidden overflow-y-auto`}
          >
            <FormArea>
              {/*  Lead Status */}
              <FeildWraper width="100%">
                <FormLabel required>Lead Status</FormLabel>

                <SelectSearch
                  name="leadstatus"
                  placeholder={"- Select  Lead Status -"}
                  onChange={(val) => {
                    formik.setFieldValue("leadstatus", val);
                  }}
                  value={formik.values?.leadstatus}
                  options={statusOptions}
                  onBlur={() =>
                    formik.setFieldTouched("leadstatus", true, true)
                  }
                  menuPosition="fixed"
                />
                {formik.touched.leadstatus && formik.errors.leadstatus && (
                  <FeildError>{formik.errors.leadstatus}</FeildError>
                )}
              </FeildWraper>
            </FormArea>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            Update Lead Status
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default UpdateLeadStatus;
